class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      setTimeout(() => {
        if ($('.cart-items').find('inventory-loc-switcher').length) {
        } else {
          
          $('.cart-items').find('.ship_from_th').css('display', 'none');
          $('.cart-items').addClass('no-shipping-country');
          $('.cart-item__totals').addClass('no_ship');
        }
      },1000)
      cartItems.updateQuantity(this.dataset.key, 0);
    });
  }
}


customElements.define('cart-remove-button', CartRemoveButton);


class InventoryLocationSwitcher extends HTMLElement {
  constructor() {
    super();
    this.currentVariant = this.querySelector('summary')?.dataset.key;
    this.otherOptions = this.querySelectorAll('details .co-value');
    Array.from(this.otherOptions).forEach(option=>{
      option.addEventListener('click', (event) => {
        event.preventDefault();
        const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
        cartItems.updateQuantity(this.currentVariant, 0, null, {
          id: event.target.dataset.variantId,
          quantity: Math.min(this.closest('.cart-item').querySelector('.quantity__input')?.value, Number(event.target.dataset.variantLimit))
        });
      });
    })
  }
}


customElements.define('inventory-loc-switcher', InventoryLocationSwitcher);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.key, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, replacement, replace) {

    if(!replace) {
      this.enableLoading(line, replacement ? 'country' : 'quantity');
    }

    const bodyObj = {
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
      attributes: {
        is_human: true
      }
    }
    
    if(!replace) {
      bodyObj.quantity = quantity;
      bodyObj.id = line;
    } else {
      bodyObj.items = [
        {
          id: line,
          quantity
        }
      ]
    }

    const body = JSON.stringify(bodyObj);

    fetch(`${replace ? routes.cart_add_url : routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        if(replacement) {
          this.updateQuantity(replacement.id, Number(replacement.quantity), null, null, line);
          return;
        }

        
          if ($('.cart-items').find('inventory-loc-switcher').length) {
          } else {
            $('.cart-items').find('.ship_from_th').css('display', 'none');
            $('.cart-items').addClass('no-shipping-country');
            $('.cart-item__totals').addClass('no_ship');
          }
        

        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
this.getSectionsToRender().forEach((section => {
  if(!(section.id === "main-cart-items" && parsedState.items.length > 0)){
    // Replace entire section
    const elementToReplace =
      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
    elementToReplace.innerHTML =
      this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
  } else {
    // Replace individual line item
    const lineToReplace = document.querySelector(`#CartItem-${(replace ? replace : line).split(':').join('')}`);
    
    // 🔧 FIX: Better selector for finding the updated line
    const updatedLine = this.getSectionInnerHTML(
      parsedState.sections[section.section], 
      replace ? '.cart-item:first-child' : `#CartItem-${line.split(':').join('')}`, 
      true
    );

    // 🔧 FIX: Only remove if quantity is actually 0, otherwise something went wrong
    if(updatedLine){
      lineToReplace.parentElement.replaceChild(updatedLine, lineToReplace);
    } else if (quantity == 0) {
      // Only remove if we're actually trying to set quantity to 0
      lineToReplace.parentElement.removeChild(lineToReplace);
    } else {
      // 🔧 FIX: If updatedLine is null but quantity isn't 0, refresh the entire cart
      console.warn('Could not find updated line item, refreshing entire cart section');
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    }
  }
}))

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line.split(':').join('')}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch((err) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector, asNode) {
    const element = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
    return asNode ? element : element.innerHTML
  }

  enableLoading(line, type) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line.split(':').join('')} ${type === 'quantity' ? '.cart-item__totals' : '.cart-item__country'} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line.split(':').join('')} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};



